
<template>
    <div class="box-container">
      <v-card class="box" :class="{'primary--text': color !== 'primary'}" :dark="color === 'primary'" :color="color">
        <v-icon :class="{'primary--text': color !== 'primary'}">{{icon}}</v-icon>
        <div class="label">
          {{ label }}
        </div>
        <div class="value">
          {{ value || 0 }}
        </div>
      </v-card>
    </div>
</template>
<script>

export default {
  name: 'box',
  props: ['value', 'label', 'icon', 'color'],
  data () {
    return {
    };
  },
  methods: {
    getData () {

    }
  }
};
</script>
<style lang="scss">
.box-container {
  .box {
    padding: 38px;
    min-height: 180px;
    position: relative;
    .icon {
      font-size: 30px;
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .value {
      font-size: 24px;
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .label {
      font-size: 16px;
      position: absolute;
      bottom: 10px;
      left: 10px;
    }
  }
}
</style>
